
/**
 * GSC MEMORY & HARDWARE MANAGER - V112.0 (Zero Leak Edition)
 */
import { terminateWorkerInstance } from "./workerFactory";

let audioContext: AudioContext | null = null;
const sessionRegistry = new Map<string, Set<string>>();

/**
 * registerURL - Point d'entrée unique pour la création d'URLs de Blobs.
 * Garantit que chaque URL est tracée pour être révoquée.
 */
export function registerURL(blob: Blob | MediaSource, sessionId: string = "default"): string {
  const url = URL.createObjectURL(blob);
  if (!sessionRegistry.has(sessionId)) {
    sessionRegistry.set(sessionId, new Set());
  }
  sessionRegistry.get(sessionId)!.add(url);
  return url;
}

/**
 * registerURLManual - Pour les URLs déjà créées (compatibilité).
 */
export function registerURLManual(url: string | null, sessionId: string = "default"): string {
  if (!url) return "";
  if (!sessionRegistry.has(sessionId)) {
    sessionRegistry.set(sessionId, new Set());
  }
  sessionRegistry.get(sessionId)!.add(url);
  return url;
}

export function purgeSession(sessionId: string) {
  const resources = sessionRegistry.get(sessionId);
  if (resources) {
    resources.forEach(url => {
        try { URL.revokeObjectURL(url); } catch (e) {}
    });
    sessionRegistry.delete(sessionId);
  }
}

export async function cleanupAllMemory() {
  terminateWorkerInstance();
  // On nettoie TOUTES les sessions
  sessionRegistry.forEach((_, id) => purgeSession(id));
  sessionRegistry.clear();

  if (audioContext && audioContext.state !== "closed") {
    try { await audioContext.close(); } catch (e) {}
  }
  audioContext = null;
}

export async function getSharedAudioContext(): Promise<AudioContext> {
  if (!audioContext || audioContext.state === "closed") {
    const AudioContextClass = (window as any).AudioContext || (window as any).webkitAudioContext;
    audioContext = new AudioContextClass({ latencyHint: 'interactive' });
  }
 if (!audioContext) {
  audioContext = new AudioContext();
}

if (audioContext.state === "suspended") {
  try { await audioContext.resume(); } catch {}
}

return audioContext;

}

const TOKEN_KEY = "gsc_active_tokens";
export function registerSecureToken(token: string) {
    const current = JSON.parse(sessionStorage.getItem(TOKEN_KEY) || "[]");
    current.push(token);
    sessionStorage.setItem(TOKEN_KEY, JSON.stringify(current));
}

export function consumeCaptureToken(t: string): boolean { 
    const current: string[] = JSON.parse(sessionStorage.getItem(TOKEN_KEY) || "[]");
    const idx = current.indexOf(t);
    if (idx !== -1) {
        current.splice(idx, 1);
        sessionStorage.setItem(TOKEN_KEY, JSON.stringify(current));
        return true;
    }
    return false; 
}

export function isLowPowerMode(): boolean { return false; }
